var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.container }, [
    _c("div", [
      _c(
        "svg",
        {
          class: [_vm.$style.close, "lightbox__close__icon"],
          attrs: { viewBox: "0 0 17 16" }
        },
        [
          _c(
            "g",
            {
              staticClass: "lightbox__close__icon",
              attrs: {
                stroke: "#1B2838",
                "stroke-width": "2",
                fill: "none",
                "fill-rule": "evenodd",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }
            },
            [
              _c("path", {
                staticClass: "lightbox__close__icon",
                attrs: { d: "M1 1l15 14M16 1L1 15" }
              })
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { class: [_vm.$style.imageContainer, "shopkeep-to-lightspeed"] }),
    _vm._v(" "),
    _c("h2", { class: [_vm.$style.heading] }, [
      _vm._v("ShopKeep is now part of the Lightspeed family.")
    ]),
    _vm._v(" "),
    _c("p", { class: _vm.$style.body }, [
      _vm._v(
        "Our team will help you find powerful POS solutions tailored to your business."
      )
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        class: _vm.$style.button,
        attrs: { href: _vm.buttonUrl },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.buttonClicked.apply(null, arguments)
          }
        }
      },
      [_vm._v(_vm._s(_vm.buttonText))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }